import styled from "styled-components";
import { blackColor } from "../../constants/colors";

const EmailBlock = styled.div``;

EmailBlock.Title = styled.div`
  margin-top: 40px;
  margin-bottom: 7px;
`;
EmailBlock.Text = styled.div`
  margin-bottom: 30px;
`;
EmailBlock.Input = styled.div`
  margin-bottom: 24px;
  position: relative;
  input {
    font-size: 18px !important;
    line-height: 20px !important;
    font-weight: 500 !important;
    color: ${blackColor} !important;
  }
`;
EmailBlock.Terms = styled.div`
  p,
  a {
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    color: #8b8b8b;
  }
  margin-bottom: 56px;
`;
EmailBlock.Button = styled.div``;
EmailBlock.Bottom = styled.div`
  p {
    //color: #8b8b8b;
  }
`;
EmailBlock.Bottom.Text = styled.div``;

export { EmailBlock };
